import GetCoinList from "./GetCoinList";
import GetCoinWithdrawFeeList from "./GetCoinWithdrawFeeList";
import GetCwalletUserInfo from "./GetCwalletUserInfo";
import GetFaitList from "./GetFaitList";
import GetCoinInfo from "./GetCoinInfo";
import GetCoinPrice from "./GetCoinPirce";
import GetSwapCoinList from "./GetSwapCoinList";
import GetChainList from "./GetChainList";

export default function Index() {
  return (
    <>
      <GetCoinList />
      <GetCoinInfo />
      <GetCoinPrice />
      <GetCwalletUserInfo />
      <GetCoinWithdrawFeeList />
      <GetFaitList />
      <GetSwapCoinList />
      <GetChainList />
    </>
  );
}
